import React, { FC, ReactNode } from 'react'
import ModalWrapper from '../../components/Modal/ModalWrapper'
import CrossIcon from '../../icons/cross.svg'

interface ITagEditorModalProps {
  title: string
  onClose: () => void
  children: ReactNode
}

const TagEditorModal: FC<ITagEditorModalProps> = ({
  title,
  onClose,
  children,
}) => (
  <ModalWrapper className="tag-editor-modal">
    <button
      className="tag-editor-modal_backdrop clear-button"
      onClick={onClose}
    />
    <div className="tag-editor-modal_dialog">
      <div className="tag-editor-modal_title">{title}</div>
      <CrossIcon className="tag-editor-modal_close" onClick={onClose} />
      {children}
    </div>
  </ModalWrapper>
)

export default TagEditorModal
